import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Spinner,
  Row,
  Label,
  Card,
  CardTitle,
} from 'reactstrap';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import 'react-quill/dist/quill.bubble.css';
import {
  Separator,
  Colxx,
} from '../../../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Twilio_Templates,
  postAPI_GuestMessagingReservation_SendMessage,
  post_API_Send_Custom_Message,
  aPI_Contacts_Eligible,
  postAPI_Validate_Twilio_Template,
} from '../../../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../../../components/common/react-notifications';
import countryCodes from '../../../../../../../../data/dial_code';
import moment from 'moment';

const STATUS_OPTIONS = [
  { label: 'In House', value: 'InHouse' },
  { label: 'Arrived Today', value: 'ArrivedToday' },
  { label: 'Arrived Yesterday', value: 'ArrivedYesterday' },
  { label: 'Departing Today', value: 'DepartingToday' },
  { label: 'Departing Tomorrow', value: 'DepartingTomorrow' },
  { label: 'Departed Today', value: 'DepartedToday' },
  { label: 'Departed Yesterday', value: 'DepartedYesterday' },
];
const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);
const PLACEHOLDER_VALUE_MAP = {
  guest_first_name: (r) => r?.firstName || '',
  guest_last_name: (r) => r?.lastName || '',
  guest_phone: (r) => r?.phone || '',
  guest_email: (r) => r?.email || '',
  room_number: (r) => r?.roomNumber || '',
  room_type: (r) => r?.roomTypeName || '',
  check_in_date: (r) => formatDate(r?.arrivalDate || ''),
  check_out_date: (r) => formatDate(r?.departureDate || ''),
};
const BULK_LABEL_MAP = {
  guest_first_name: 'First Name',
  guest_last_name: 'Last Name',
  guest_phone: 'Phone Number',
  guest_email: 'Email Address',
  room_number: 'Room Number',
  room_type: 'Room Type',
  check_in_date: 'Arrival Date',
  check_out_date: 'Departure Date',
};

const styles = `
      .ql-toolbar {  
        border: 1px solid #ccc !important;            
         border-radius: 0px!important;  
         background:white;      
      }
 
      .ql-container{
        border: 1px solid #ccc !important;
        border-radius: 0px!important;  
        background:white;      
      }
 
      .dropzone {
        min-height: 40px !important;
        cursor:pointer;
    }
  `;

const SMStab = ({
  propertyId,
  preFillPhoneNumber,
  showStatusFilter = false,
  showPhoneNumber = false,
  reservationId,
  source,
  onStatusChange,
  totalCount,
  loadingCount,
  reservationData,
  recipientId,
}) => {
  const { userName, timeZone } = useSelector(({ settings }) => ({
    userName: settings.userName,
    timeZone: settings.timeZone,
  }));
  const [templateList, setTemplateList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
  const [smsData, setSmsData] = useState({
    templateId: '',
    to: '',
    countryCode: '+64',
    rawNumber: preFillPhoneNumber || '',
    text: '',

    isCustomMessage: false,
    templateName: '',
    saveAsTemplate: true,
    placeholders: [],
  });
  const [checked, setChecked] = useState(false);
  const MARKETING_CONSENT_OPTIONS = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];
  const [marketingConsent, setMarketingConsent] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);
  const [eligibleLoading, setEligibleLoading] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [memberEligibleCount, setMemberEligibleCount] = useState(0);
  const showMarketingConsent = source === 'MembersBulk';
  const showTagList = source === 'MembersBulk';

  const fetchEligibleCount = async (consent, tag) => {
    setEligibleLoading(true);
    const res = await AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts_Eligible}?groupId=${getGroupID()}&propertyId=${propertyId}&marketingConsent=${consent}&tag=${tag}`,
    });

    setMemberEligibleCount(res.data?.eligibleCount || 0);
    setTagList(
      (res.data?.tags || []).map((x) => ({
        label: x,
        value: x,
      }))
    );
    setEligibleLoading(false);
  };
  const [placeholderMap, setPlaceholderMap] = useState({});
  const [placeholderErrors, setPlaceholderErrors] = useState({});
  useEffect(() => {
    if (statusMessage.text) {
      const timer = setTimeout(() => {
        setStatusMessage({ text: '', type: '' });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [statusMessage]);

  useEffect(() => {
    if (!showMarketingConsent) {
      setMarketingConsent(null);
      setMemberEligibleCount(0);
    }
  }, [showMarketingConsent]);

  useEffect(() => {
    if (showTagList) {
      fetchEligibleCount('', '');
    }
  }, [showTagList]);

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
    }).then((res) => {
      setTemplateList(res.data);
      if (preFillPhoneNumber !== undefined && preFillPhoneNumber != null) {
        let raw = preFillPhoneNumber || '';
        let dialCode = '+64';
        countryCodes.map((m) => {
          if (raw.startsWith(m.dial_code)) {
            raw = raw.replace(m.dial_code, '');
            dialCode = m.dial_code;
          }
        });
        setSmsData((prev) => ({
          ...prev,
          rawNumber: raw,
          countryCode: dialCode,
          to: `${dialCode}${raw}`,
        }));
      }
    });
  }, [propertyId, preFillPhoneNumber]);

  const handleTemplate = (e) => {
    const value = e.target.value;

    // Custom Message selected
    if (value === 'CUSTOM_MESSAGE') {
      setPlaceholderMap({});
      setPlaceholderErrors({});
      setSmsData((prev) => ({
        ...prev,
        isCustomMessage: true,
        templateId: '',
        templateName: '',
        text: '',
        placeholders: [],
        saveAsTemplate: prev.saveAsTemplate,
      }));

      return;
    }

    const selectedTemplate = templateList.find((t) => t.templateId === value);

    if (!selectedTemplate) {
      setSmsData((prev) => ({
        ...prev,
        isCustomMessage: false,
        templateId: '',
        text: '',
        placeholders: [],
      }));
      return;
    }

    const text = selectedTemplate.templateBody || '';

    const placeholders = (selectedTemplate.placeholders || []).map((ph) => {
      const placeholderKey = `{{${ph.name}}}`;

      const value =
        source === 'Manually' || source === 'Members'
          ? PLACEHOLDER_VALUE_MAP[ph.value]?.(reservationData) || ''
          : '';

      return {
        key: placeholderKey,
        sourceKey: ph.value,
        label:
          BULK_LABEL_MAP[ph.value] ||
          ph.value.replaceAll('_', ' ').toUpperCase(),
        value,
      };
    });

    setSmsData((prev) => ({
      ...prev,
      isCustomMessage: false,
      templateId: selectedTemplate.templateId,
      text,
      placeholders,
    }));
  };

  const handlePlaceHolders = (value, index) => {
    setSmsData((prev) => {
      const placeholders = [...prev.placeholders];
      placeholders[index].value = value;

      return {
        ...prev,
        placeholders,
      };
    });
  };
  const extractPlaceholders = (text) => {
    const matches = text.match(/{{(.*?)}}/g) || [];

    return [...new Set(matches.map((m) => m.replace(/[{}]/g, '')))];
  };
  const mobileNumber = showPhoneNumber ? smsData?.rawNumber || '' : '';
  const canSend = !showPhoneNumber || mobileNumber.trim().length > 0;

  const sendSmsMessage = async () => {
    if (!canSend) {
      NotificationManager.error(
        '',
        'No mobile number available for this contact.',
        3000
      );
      return;
    }
    let templateData = {};
    let placeholders = [...smsData.placeholders];
    if (!smsData.placeholders || !Array.isArray(smsData.placeholders)) {
      NotificationManager.error('', 'Invalid template placeholders.', 3000);
      return;
    }

    if (source === 'CustomMessage') {
      placeholders.forEach((m) => {
        const key = m?.key?.replaceAll('{', '').replaceAll('}', '');
        templateData[key] = m?.value;
      });
      let payload = {
        groupId: getGroupID(),
        propertyId,
        templateId: smsData?.templateId,
        message: smsData?.text,
        placeholderValues: templateData,
      };
      // console.log('pay', payload, templateData);
      try {
        setLoading(true);
        const res = await AxiosAPI({
          method: 'post',
          url: post_API_Send_Custom_Message,
          data: payload,
        });
        const backendMsg =
          typeof res?.data === 'string'
            ? res.data
            : res?.data?.statusMessage || res?.data?.message || 'Message sent';
        setStatusMessage({
          text: backendMsg,
          type: 'success',
        });
      } catch (error) {
        console.error(error);
        setStatusMessage({
          text: 'Message Failed',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }

    if (
      source !== 'CustomMessage' &&
      (source === 'Bulk' ||
        source === 'MembersBulk' ||
        placeholders.filter((f) => f.value === '').length === 0)
    ) {
      const isBulkMode = source === 'Bulk' || source === 'MembersBulk';

      if (
        isBulkMode ||
        placeholders.filter((f) => f.value === '').length === 0
      ) {
        placeholders.forEach((m) => {
          const key = m.key.replaceAll('{', '').replaceAll('}', '');
          templateData[key] = isBulkMode ? m.sourceKey : m.value;
        });
        let payload = {
          groupId: getGroupID(),
          propertyId,
          channel: 'SMS',
          templateId: smsData.templateId,
          message: smsData.text,
          placeholderValues: templateData,
          CreatedBy: userName,
        };
        if (source === 'Members') {
          payload = {
            ...payload,
            sourceType: 'Members',
            recipientId: recipientId,
            MobileNumber: smsData.to,
            StatusFilter: 'Individual',
          };
        }
        if (source === 'MembersBulk') {
          payload = {
            ...payload,
            sourceType: 'MembersBulk',
            marketingConsent: marketingConsent?.value || '',
            tag: selectedTag?.value || '',
            StatusFilter: 'InHouse',
          };
        }
        if (source === 'Manually') {
          payload = {
            ...payload,
            reservationId,
            MobileNumber: smsData.to,
            StatusFilter: 'Individual',
          };
        }
        if (source === 'Bulk') {
          if (!selectedStatus) {
            NotificationManager.error(
              '',
              'Please select a status before sending message.',
              3000
            );
            return;
          }
          payload = {
            ...payload,
            timeZone,
            StatusFilter: selectedStatus.value,
          };
        }

        try {
          setLoading(true);

          const res = await AxiosAPI({
            method: 'post',
            url: postAPI_GuestMessagingReservation_SendMessage,
            data: payload,
          });

          const backendMsg =
            typeof res?.data === 'string'
              ? res.data
              : res?.data?.statusMessage ||
              res?.data?.message ||
              'Message sent';
          // Status message only for Manual mode
          if (source === 'Manually') {
            setStatusMessage({
              text: backendMsg,
              type: 'success',
            });
          } else {
            setStatusMessage({
              text: backendMsg,
              type: 'success',
            });
          }
        } catch (error) {
          console.error(error);

          const backendError =
            typeof error?.response?.data === 'string'
              ? error.response.data
              : error?.response?.data?.statusMessage ||
              error?.response?.data?.message ||
              'Failed to send SMS message.';
          if (source === 'Manually') {
            setStatusMessage({
              text: backendError,
              type: 'error',
            });
          } else {
            setStatusMessage({
              text: 'Message Failed',
              type: 'error',
            });
          }
        } finally {
          setLoading(false);
        }
      }
    }
  };
  const renderBulkStatus = (msg) => {
    if (!msg) return null;

    // Only format when queued info exists
    if (!msg.toLowerCase().includes('queued')) {
      return msg;
    }

    // Split on both "|" and "," safely
    const parts = msg
      .split(/[\|,]/)
      .map((p) => p.trim())
      .filter((p) => p !== '');

    const formatPart = (part, color) => {
      if (!part.includes(':')) return part;

      const [label, value] = part.split(':');

      const cleanLabel =
        label.trim().charAt(0).toUpperCase() +
        label.trim().slice(1).toLowerCase();

      const cleanValue = value?.trim();

      return (
        <span style={{ color, fontWeight: 600 }}>
          {cleanLabel}
          {cleanValue ? `: ${cleanValue}` : ''}
        </span>
      );
    };

    const header = parts[0]; // Bulk messages processed
    const queuedPart = formatPart(parts[1], 'green');
    const failedPart = formatPart(parts[2], 'red');

    return (
      <span>
        {header} {queuedPart && <>| {queuedPart} </>}
        {failedPart && <>| {failedPart}</>}
      </span>
    );
  };

  const renderManualStatus = (msg) => {
    if (!msg) return null;

    const normalized = msg.trim().toLowerCase();

    const formatted = normalized.charAt(0).toUpperCase() + normalized.slice(1);

    const isQueued = normalized.includes('queued');

    return (
      <span
        style={{
          color: isQueued ? 'green' : 'red',
          fontWeight: 600,
        }}
      >
        {formatted}
      </span>
    );
  };
  const validateMessage = async () => {
    if (!smsData.templateName.trim()) {
      NotificationManager.error('', 'Please enter template name.', 3000);
      return;
    }

    if (!smsData.text.trim()) {
      NotificationManager.error('', 'Please enter message.', 3000);
      return;
    }

    const extracted = extractPlaceholders(smsData.text);

    let placeholders = [];

    if (extracted.length > 0) {
      const errors = {};

      extracted.forEach((p) => {
        if (!placeholderMap[p]) {
          errors[p] = true;
        }
      });

      if (Object.keys(errors).length > 0) {
        setPlaceholderErrors(errors);

        NotificationManager.error(
          '',
          'Please select a field for every placeholder.',
          3000
        );

        return;
      }

      placeholders = extracted.map((p) => ({
        name: p,
        value: placeholderMap[p],
      }));
    }

    try {
      setLoading(true);

      const { data } = await AxiosAPI({
        method: 'post',
        url: postAPI_Validate_Twilio_Template,
        data: {
          groupId: getGroupID(),
          propertyId,
          name: smsData.templateName,
          templateBody: smsData.text,
          language: 'en',
          isTemplate: smsData.saveAsTemplate,
          createdBy: userName,
          placeholders,
        },
      });

      NotificationManager.success('', 'Message validated successfully.', 3000);

      let selectedTemplate = null;

      if (data.isTemplate) {
        // Refresh template list
        const res = await AxiosAPI({
          method: 'get',
          url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
        });

        setTemplateList(res.data);

        selectedTemplate = res.data.find(
          (t) => t.templateId === data.templateId
        );
      } else {
        // Fetch one-off template by Id
        const { data: template } = await AxiosAPI({
          method: 'get',
          url: `${gAPI_Twilio_Templates}/${data.id}?group_id=${getGroupID()}`,
        });

        setTemplateList((prev) => {
          if (prev.some((t) => t.templateId === template.templateId)) {
            return prev;
          }

          return [...prev, template];
        });

        selectedTemplate = template;
      }

      if (selectedTemplate) {
        setSmsData((prev) => ({
          ...prev,
          isCustomMessage: false,
          templateId: selectedTemplate.templateId,
          text: selectedTemplate.templateBody,
          placeholders: (selectedTemplate.placeholders || []).map((ph) => ({
            key: `{{${ph.name}}}`,
            sourceKey: ph.value,
            label:
              BULK_LABEL_MAP[ph.value] ||
              ph.value.replaceAll('_', ' ').toUpperCase(),
            value:
              source === 'Manually' || source === 'Members'
                ? PLACEHOLDER_VALUE_MAP[ph.value]?.(reservationData) || ''
                : '',
          })),
        }));
      }

      setPlaceholderMap({});
      setPlaceholderErrors({});
    } catch (error) {
      NotificationManager.error(
        '',
        error?.response?.data?.message || 'Validation failed.',
        3000
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Fragment>
      <Card className=" mt-2 " style={{ boxShadow: 'none' }}>
        <CardTitle className="ml-3">Send SMS</CardTitle>

        <style>{styles}</style>
        <Row className="ml-2 mr-2">
          {showStatusFilter && source === 'Bulk' && (
            <Colxx md="12" className="mb-2">
              <Label>Select status</Label>
              <Select
                className="react-select"
                classNamePrefix="react-select"
                options={STATUS_OPTIONS}
                placeholder="Select status"
                value={selectedStatus}
                onChange={(val) => {
                  setSelectedStatus(val);
                  if (val && onStatusChange) {
                    onStatusChange(val.value);
                  }
                }}
                isClearable
              />
              {source === 'Bulk' && selectedStatus && (
                <div className="mt-1" style={{ fontSize: '13px' }}>
                  {loadingCount ? (
                    'Fetching guest count...'
                  ) : (
                    <b>
                      SMS will be sent to {totalCount} guests with valid, unique mobile numbers.
                    </b>
                  )}
                </div>
              )}
            </Colxx>
          )}

          {showMarketingConsent && showTagList && !eligibleLoading && (
              <Colxx md="12" className="mb-2">
                <div className="mt-1" style={{ fontSize: '13px' }}>
                  <b>Eligible Members: {memberEligibleCount}</b>
                </div>
              </Colxx>
            )}
          {showMarketingConsent && (
            <Colxx md="12" className="mb-2">
              <Label>Marketing Consent</Label>
              <Select
                className="react-select"
                classNamePrefix="react-select"
                options={MARKETING_CONSENT_OPTIONS}
                placeholder="All Eligible Members"
                value={marketingConsent}
                isClearable
                onChange={(val) => {
                  setMarketingConsent(val);

                  fetchEligibleCount(
                    val?.value || '',
                    selectedTag?.value || ''
                  );
                }}
              />
            </Colxx>
          )}
          {showTagList && (
            <Colxx md="12" className="mb-2">
              <Label>Tag</Label>

              <Select
                className="react-select"
                classNamePrefix="react-select"
                options={tagList}
                value={selectedTag}
                placeholder="All Tags"
                isClearable
                onChange={(val) => {
                  setSelectedTag(val);

                  fetchEligibleCount(
                    marketingConsent?.value || '',
                    val?.value || ''
                  );
                }}
              />
            </Colxx>
          )}

          <Colxx md="12" className="mb-2">
            <Label>Template</Label>
            <Input
              type="select"
              name="Template"
              value={
                smsData.isCustomMessage
                  ? 'CUSTOM_MESSAGE'
                  : smsData.templateId || ''
              }
              onChange={handleTemplate}
            >
              <option value="">Please Select</option>

              {/* Always show first */}
              <option value="CUSTOM_MESSAGE">Custom Message</option>

              {Array.isArray(templateList) &&
                templateList
                  .filter(
                    (t) =>
                      Array.isArray(t.channel) &&
                      t.channel.some((c) => c && c.toLowerCase() === 'sms')
                  )
                  .map((m) => (
                    <option key={m.templateId} value={m.templateId}>
                      {m.name}
                    </option>
                  ))}
            </Input>
          </Colxx>
          {smsData.isCustomMessage ||
            (smsData.templateId && smsData.templateId !== '') ? (
            <Fragment>
              {loading ? (
                <div className="text-center">
                  <Spinner color="primary" className="mb-1" />
                </div>
              ) : smsData.isCustomMessage ? (
                <Fragment>
                  <Colxx md="12" className="mb-2">
                    <Label>Template Name</Label>
                    <Input
                      type="text"
                      value={smsData.templateName}
                      onChange={(e) =>
                        setSmsData((prev) => ({
                          ...prev,
                          templateName: e.target.value,
                        }))
                      }
                    />
                  </Colxx>

                  <Colxx md="12" className="mb-2">
                    <Label>Message</Label>

                    <Input
                      type="textarea"
                      rows={4}
                      value={smsData.text}
                      onChange={(e) =>
                        setSmsData((prev) => ({
                          ...prev,
                          text: e.target.value,
                        }))
                      }
                    />

                    <div className="mt-2">
                      {extractPlaceholders(smsData.text).map((ph) => {
                        const hasError = placeholderErrors[ph];

                        return (
                          <div key={ph} style={{ marginBottom: 8 }}>
                            <InputGroup
                              style={{
                                border: hasError
                                  ? '1px solid red'
                                  : '1px solid #ddd',
                              }}
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText style={{ width: 120 }}>
                                  {`{{${ph}}}`}
                                </InputGroupText>
                              </InputGroupAddon>

                              <Input
                                type="select"
                                value={placeholderMap[ph] || ''}
                                onChange={(e) => {
                                  setPlaceholderMap({
                                    ...placeholderMap,
                                    [ph]: e.target.value,
                                  });

                                  setPlaceholderErrors((prev) => {
                                    const copy = { ...prev };
                                    delete copy[ph];
                                    return copy;
                                  });
                                }}
                              >
                                <option value="">Select Field</option>

                                {Object.entries(BULK_LABEL_MAP).map(
                                  ([key, label]) => (
                                    <option key={key} value={key}>
                                      {label}
                                    </option>
                                  )
                                )}
                              </Input>
                            </InputGroup>

                            {hasError && (
                              <div style={{ color: 'red', fontSize: 12 }}>
                                Selection required
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </Colxx>

                  <Colxx md="12" className="mb-3">
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <input
                        id="saveTemplate"
                        type="checkbox"
                        checked={smsData.saveAsTemplate}
                        readOnly
                        onClick={() =>
                          setSmsData((prev) => ({
                            ...prev,
                            saveAsTemplate: !prev.saveAsTemplate,
                          }))
                        }
                        style={{
                          width: '16px',
                          height: '16px',
                          margin: 0,
                          cursor: 'pointer',
                          flexShrink: 0,
                        }}
                      />

                      <label
                        htmlFor="saveTemplate"
                        style={{
                          marginLeft: '8px',
                          marginBottom: 0,
                          cursor: 'pointer',
                          userSelect: 'none',
                          fontSize: '14px',
                        }}
                      >
                        Save as template for future use
                      </label>
                    </div>
                  </Colxx>

                  <Colxx md="12" className="mb-2">
                    <Button color="primary" size="sm" onClick={validateMessage}>
                      Validate Message
                    </Button>
                  </Colxx>
                </Fragment>
              ) : (
                <Fragment>
                  <Colxx md="12" className="mb-2">
                    <Label>Message</Label>
                    <Input
                      type="textarea"
                      value={smsData?.text}
                      name="conditions"
                      disabled={true}
                    // onChange={handleChangeConditionsArr}
                    />
                  </Colxx>

                  {smsData.placeholders?.map((ph, index) => (
                    <Colxx md="12" className="mb-2" key={index}>
                      <Label>Add Placeholder Value</Label>

                      <InputGroup>
                        <InputGroupAddon>
                          <InputGroupText style={{ width: '138px' }}>
                            {ph.key}
                          </InputGroupText>
                        </InputGroupAddon>

                        <Input
                          type="text"
                          value={
                            source === 'Bulk' || source === 'MembersBulk'
                              ? ph.label
                              : ph.value
                          }
                          disabled={
                            source === 'Bulk' || source === 'MembersBulk'
                          }
                          onChange={(e) =>
                            source !== 'Bulk' &&
                            source !== 'MembersBulk' &&
                            handlePlaceHolders(e.target.value, index)
                          }
                        />
                      </InputGroup>
                    </Colxx>
                  ))}

                  {showPhoneNumber && (
                    <Colxx md="12" className="mb-2">
                      <Label>Mobile Number</Label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <Input
                            type="select"
                            name="countryCode"
                            value={smsData.countryCode || '+64'}
                            onChange={(e) =>
                              setSmsData((prev) => ({
                                ...prev,
                                countryCode: e.target.value,
                                to: `${e.target.value}${prev.rawNumber || ''}`,
                              }))
                            }
                            style={{
                              width: '150px',
                              textAlign: 'center',
                              cursor: 'pointer',
                            }}
                          >
                            {countryCodes.map((c) => (
                              <option key={c.code} value={c.dial_code}>
                                {c.code} {c.dial_code} ({c.name})
                              </option>
                            ))}
                          </Input>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Enter phone number"
                          value={smsData.rawNumber || ''}
                          style={{
                            backgroundColor: 'white',
                            cursor: 'text',
                          }}
                          onChange={(e) => {
                            const number = e.target.value.replace(/\D/g, '');
                            setSmsData((prev) => ({
                              ...prev,
                              rawNumber: number,
                              to: `${prev.countryCode || '+64'}${number}`,
                            }));
                          }}
                        />
                      </InputGroup>
                      {!canSend && (
                        <div
                          style={{
                            color: '#dc3545',
                            fontSize: '12px',
                            marginTop: '5px',
                          }}
                        >
                          <b>No mobile number available for this contact.</b>
                        </div>
                      )}
                    </Colxx>
                  )}
                </Fragment>
              )}
            </Fragment>
          ) : null}
        </Row>
        <div className="text-center my-3">
          {statusMessage.text && (
            <div className="mb-2 font-medium">
              <b>
                {source === 'Bulk' || source === 'MembersBulk'
                  ? renderBulkStatus(statusMessage.text)
                  : renderManualStatus(statusMessage.text)}
              </b>
            </div>
          )}

          {smsData?.templateId && smsData?.templateId !== '' ? (
            <>
              <Separator className="mb-3" />
              <Button
                color="primary"
                size="sm"
                onClick={sendSmsMessage}
                disabled={!canSend}
              >
                Send
              </Button>
            </>
          ) : null}
          {/* <Button className='ml-2' color="secondary" size="xs" onClick={toggle}>
            Cancel
          </Button> */}
        </div>
      </Card>
    </Fragment>
  );
};
export default SMStab;
